export const ERROR_THEME = {
  palette: {
    primary: {
      main: '#F03',
      black: '#000000',
    },
    secondary: {
      contrastText: '#fff',
      main: '#f44336',
    },
    icon: {
      main: '#F03',
    },
    success: { main: '#00D41F' },
    warning: { main: '#EEC303' },
    error: { main: '#FF0000' },
    info: { main: '#008DFF' },
    breadcrumb: {
      color: '#F03',
      backgroundColor: '#fff',
    },
  },
  borderBottom: {
    borderBottom: '4px solid #F03',
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '.relativeContainer': {
          minHeight: `calc(100vh - 85px)`,
        },
      },
    },
  },
}
